export default __webpack_public_path__ + "static/flipImg3-2ce6f7b33baf684e07d642e5de985340.webp";